var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "common-content",
        [
          _c(
            "div",
            { staticClass: "project-detail-title section fp-auto-height" },
            [
              _c("nuxt-link", { attrs: { to: "/project" } }, [
                _c("h4", [_vm._v(_vm._s(_vm.pro))])
              ]),
              _c("div", [
                _c("h2", { staticClass: "project-name" }, [
                  _vm._v(_vm._s(_vm.pageData.title))
                ]),
                _c(
                  "ul",
                  { staticClass: "project-tabs" },
                  [
                    _c(
                      "li",
                      {
                        class: { active: _vm.idx === 0 },
                        on: {
                          click: function($event) {
                            return _vm.toggle(0, "all")
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.all))]
                    ),
                    _vm._l(_vm.types, function(item, index) {
                      return _c(
                        "li",
                        {
                          class: { active: index + 1 === _vm.idx },
                          on: {
                            click: function($event) {
                              return _vm.toggle(index + 1, item)
                            }
                          }
                        },
                        [_vm._v(_vm._s(item))]
                      )
                    })
                  ],
                  2
                )
              ]),
              _c("h6", [_vm._v(_vm._s(_vm.pageData.time))]),
              _c(
                "ul",
                { staticClass: "project-tabs-mobile" },
                [
                  _c(
                    "li",
                    {
                      class: { active: _vm.idx === 0 },
                      on: {
                        click: function($event) {
                          return _vm.toggle(0, "all")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.all))]
                  ),
                  _vm._l(_vm.types, function(item, index) {
                    return _c(
                      "li",
                      {
                        class: { active: index + 1 === _vm.idx },
                        on: {
                          click: function($event) {
                            return _vm.toggle(index + 1, item)
                          }
                        }
                      },
                      [_vm._v(_vm._s(item))]
                    )
                  })
                ],
                2
              )
            ],
            1
          ),
          _vm.meta === "all"
            ? _c("div", { staticClass: "project-detail_video" }, [
                _vm.pageData.video
                  ? _c("video", {
                      staticClass: "videoFull",
                      attrs: {
                        src: _vm.pageData.video,
                        "x5-playsinline": "",
                        playsinline: "",
                        "webkit-playsinline": "",
                        preload: "",
                        loop: "",
                        autoplay: "",
                        controls: "",
                        width: "100%",
                        controlslist: "nodownload",
                        poster: _vm.pageData.mainImg
                      }
                    })
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._l(_vm.pageData.imgList, function(item) {
            return _c("div", { staticClass: "project-detail_show section" }, [
              _vm.meta === "all"
                ? _c("div", [
                    _c("div", { staticClass: "imgcover" }),
                    _c("img", { attrs: { src: item.url, alt: "" } })
                  ])
                : _vm._e(),
              _vm.meta !== "all" && item.title === _vm.meta
                ? _c("div", [
                    _c("div", { staticClass: "imgcover" }),
                    _c("img", { attrs: { src: item.url, alt: "" } })
                  ])
                : _vm._e()
            ])
          }),
          _c("div", { staticClass: "section" }, [
            _c("div", { staticClass: "project-detail_text" }, [
              _c("hr"),
              _c("p", [_vm._v(_vm._s(_vm.pageData.content))])
            ]),
            _c(
              "div",
              { staticClass: "project-more" },
              [
                _vm._l(_vm.relFil, function(item) {
                  return _c(
                    "div",
                    { staticClass: "project-more_prew" },
                    [
                      _c(
                        "nuxt-link",
                        { attrs: { to: "/project/" + item.id } },
                        [
                          _c("img", { attrs: { src: item.mainImg, alt: "" } }),
                          _c("div", { staticClass: "project-modal" }, [
                            _c("div", { staticClass: "modal-text" }, [
                              _c("hr"),
                              _c("h2", [_vm._v(_vm._s(item.title))]),
                              _c("h4", [_vm._v(_vm._s(item.time))])
                            ])
                          ])
                        ]
                      )
                    ],
                    1
                  )
                }),
                _c(
                  "nuxt-link",
                  {
                    staticClass: "project-more_link",
                    attrs: { to: "/project?lang=" + _vm.lang }
                  },
                  [
                    _c("span", [_vm._v(_vm._s(_vm.more))]),
                    _c("i", { staticClass: "icon icon-arrowright" })
                  ]
                )
              ],
              2
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d6a1384a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6a1384a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/project/_id.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-d6a1384a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/project/_id.vue
// module chunks = 1